module.exports = __webpack_public_path__ + "img/bot.0164dbbd.svg";